import { ProfileView } from "@authory-packages/core";
import { theme } from "../../theme/theme";
import { VerticalSpacing } from "../VerticalSpacing";
import {
    FakeMetadata,
    ItemImageWrapper,
    ItemMockAddBtnPos,
    ItemTextWrapper,
    PlIListThumb,
    PLIThumbnail,
    PLIThumbnailPad,
    PLIViewVisibility,
    PLIWrapper,
    SecondaryTextMockWrapper,
    V3FeedDescription,
    V3FeedTitle
} from "./V3ProfileListItem.styles";
import { getCollapseBreakpoint, getDescNumLines, getTitleNumLines } from "./V3ProfileListItem.utils";
import { V3IconPlus } from "../Icons";
import { V3ButtonVariant } from "../Button/V3Button.types";
import { V3CaptionGrey35 } from "../ReusableStyledComponents/V3CaptionGrey35";
import { V3Button } from "../Button";

interface V3ProfileListItemMockProps {
    viewType: ProfileView;
    isProfileMock?: boolean;
    responsiveBreakpoint?: number;
    setAddContentOpen: () => void;
}

export const V3ProfileListItemMock = ({
    viewType = ProfileView.TwoColumnThumbnail,
    isProfileMock = true,
    responsiveBreakpoint,
    setAddContentOpen
}: V3ProfileListItemMockProps) => {
    // Views
    const isText = viewType === ProfileView.Text;
    const isList = viewType === ProfileView.List;
    const isMasonry = viewType === ProfileView.Masonry;

    const breakpoint = getCollapseBreakpoint(viewType, responsiveBreakpoint);
    const mobileView = breakpoint ? ProfileView.OneColumnThumbnail : viewType;

    const titleLines = getTitleNumLines(mobileView, true, true);
    const titleHiddenViews = isProfileMock ? [ProfileView.TwoColumnThumbnail, ProfileView.OneColumnThumbnail, ProfileView.Masonry] : [];

    return (
        <PLIWrapper
            $dash={isText}
            $isPinned={false}
            $viewType={viewType}
            $breakpoint={breakpoint}
            $isMock={isProfileMock}
            onClick={setAddContentOpen}
            style={{ overflow: "hidden" }}
        >
            {(!isList || !!breakpoint) && (
                <ItemImageWrapper $viewType={viewType} $breakpoint={breakpoint} $isPinned={false}>
                    {!isText && (
                        <PLIThumbnailPad $viewType={viewType} $breakpoint={breakpoint} $isProfileMock={isProfileMock}>
                            <PLIThumbnail $viewType={viewType} $breakpoint={breakpoint} $isProfileMock={isProfileMock} />
                        </PLIThumbnailPad>
                    )}
                </ItemImageWrapper>
            )}
            {!isMasonry && (
                <ItemTextWrapper $viewType={viewType} $breakpoint={breakpoint}>
                    <div>
                        <PLIViewVisibility
                            bottom={!isProfileMock ? theme.v3.spacings.spacing3 : undefined}
                            $viewType={viewType}
                            $breakpoint={breakpoint}
                            $hiddenViews={titleHiddenViews}
                        >
                            <V3FeedTitle $isMock as="h2" $numLines={isProfileMock ? 5 : titleLines}>
                                {Array(200).join("a ")}
                            </V3FeedTitle>
                        </PLIViewVisibility>
                        {!isProfileMock && (
                            <PLIViewVisibility
                                bottom={theme.v3.spacings.spacing3}
                                $viewType={viewType}
                                $breakpoint={breakpoint}
                                $hiddenViews={[ProfileView.TwoColumnThumbnail]}
                            >
                                <V3FeedDescription
                                    $isMock
                                    $numLines={getDescNumLines(mobileView, true, true)}
                                    $desktopNumLines={getDescNumLines(viewType, true, true)}
                                    $breakpoint={breakpoint}
                                >
                                    {Array(200).join("a ")}
                                </V3FeedDescription>
                            </PLIViewVisibility>
                        )}
                        {!isProfileMock && <FakeMetadata $isMock />}
                    </div>
                </ItemTextWrapper>
            )}
            {isList && !isProfileMock && (
                <PlIListThumb $breakpoint={breakpoint}>
                    <PLIThumbnail $viewType={viewType} />
                </PlIListThumb>
            )}
            {isProfileMock && (
                <ItemMockAddBtnPos>
                    <V3Button
                        data-intercom-target="UniversalAddContent"
                        icon={<V3IconPlus />}
                        text={isMasonry ? "Add work samples" : "Add work samples to this collection"}
                        autoWidth
                        onClick={setAddContentOpen}
                        variant={V3ButtonVariant.large}
                        minWidth={160}
                    />
                    <VerticalSpacing top={14}>
                        <SecondaryTextMockWrapper>
                            <V3CaptionGrey35>Import new content or select previously imported pieces from your Content Archive.</V3CaptionGrey35>
                        </SecondaryTextMockWrapper>
                    </VerticalSpacing>
                </ItemMockAddBtnPos>
            )}
        </PLIWrapper>
    );
};
